// Importamos las funciones necesarias desde React.
import { createContext, useContext, useState } from "react";

// Creamos un contexto llamado PremiumHistory con un valor inicial indefinido.
const PremiumHistory = createContext(undefined);

// Definimos el proveedor del contexto PremiumHistory.
export const PremiumHistoryProvider = ({ children }) => {

    // Creamos un estado para almacenar el historial 
    const [history, setHistory] = useState(
        [
            {
                id: 0,
                value: "There's no history yet"
            }
        ]
    );
  
    return (
        // Configuramos el proveedor del contexto para compartir el valor del estado `total`.
        <PremiumHistory.Provider
            value={{
                history, setHistory // Todo lo que estara disponible para los componentes hijos.
            }}
        >
            {/* Renderizamos los componentes hijos dentro del proveedor */}
            {children} 
        </PremiumHistory.Provider>
    );
};

// Creamos un hook personalizado que permite a los componentes acceder al contexto de autenticación.
export const useTotal = () => useContext(PremiumHistory);
